<template>
    <CustomHeader :text="$t('activityName.user_rank')" />
    <div class="level_container">
        <div class="top_card">
            <img src="@/assets/level/rankv2_top_bg.png" alt="">
            <div class="top_content">
                <img src="@/assets/level/level_1_1.png" alt="">
                <div>
                    <div class="text_1 level_text">{{ $t('level.currentLevel') }}</div>
                    <div class="text_2 level_name">
                        {{ dataSet.currentRankName ? dataSet.currentRankName : $t('rewards.notActivated') }}
                    </div>

                    <div class="text_1 value_text">
                        {{ $t('level.gameTurnOver') }}：
                    </div>
                    <div class="text_2 value">{{ dataSet.rankConfig.amount }}</div>
                </div>
            </div>
        </div>
        <div class="level_scroll_wrapper">
            <div class="level_list" >
                <div v-for="(item, index) in dataSet.levelList" :key="item.rank" style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                    <div class="level_item"  :class="dataSet.activeRank >= item.rank ? 'active_level' : ''">
                        <img :src="dataSet.activeRank == item.rank ? require('@/assets/level/level_1_1.png') : require('@/assets/level/level_2_0.png')"
                            alt="">
                    </div>
                    <div :style="dataSet.activeRank == item.rank ? { color: '#F9C486' } : ''"> {{ item.rank_name }}</div>
                    <div class="manual_level_bar" v-if="dataSet.levelList.length > 0">
                <div class="step_line left" :class="{ active: dataSet.activeRank > dataSet.levelList[0].rank }"></div>
                <div class="level_step"
                    :class="{ active: dataSet.activeRank >= item.rank }">
                    <div class="step_dot2">
                        <div class="step_dot"></div>
                    </div>
                    <div class="step_label">{{ Number(item.turnover_amount) }}</div>
                    <div v-if="index !== dataSet.levelList.length - 1" class="step_line"
                        :class="{ active: dataSet.activeRank >= dataSet.levelList[index + 1].rank }"></div>
                </div>
            </div>
                </div>
            </div>
        </div>
        <div class="middle_container"> <img src="@/assets/level/rankv2_middle_bg.png" alt=""></div>
        <div class="label_container">
            <div v-for="(item, index) in dataSet.rewardsList" :key="index">
                <img src="@/assets/level/rankv2_item_bg.png" alt="">
                <van-row class="label_text">
                    <van-col span="3" class="checkingDoneTick">
                        <img v-if="item.status == 2" src="@/assets/bonus/select.png" alt="">
                    </van-col>
                    <van-col span="5" class="day_text">{{ $t('common.travel') }} {{ item.day }}</van-col>
                    <van-col span="4" class="currency_text">R$ <span>{{ Number(item.reward) }}</span></van-col>
                    <van-col span="10" offset="2" class="label_img">
                        <div v-if="item.status == 2" class="select_icon"> <img src="@/assets/bonus/select.png" alt="">
                        </div>
                        <div v-if="item.status == 1" class="activeText" @click="clickOnCard"
                            :class="{ 'pop-animate': isPopping }">
                            <van-loading v-if="isLoading" size="15" type="spinner" />
                            <div v-else>{{ $t('common.notCompleted') }}</div>
                        </div>
                        <div v-if="item.status == 0" class="activeText" style="color: #7a7a7a66;">{{ $t('common.notCompleted') }}</div>

                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="bottom_text">
            <van-row style="padding-bottom: 10px;">
                <van-col span="6" class="">
                    <div class="line1"></div>
                </van-col>
                <van-col span="12" class="title">
                    <div>{{ $t('common.activityTitle') }}</div>
                </van-col>
                <van-col span="6" class="">
                    <div class="line2"></div>
                </van-col>
            </van-row>
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { LevelViewData } from '@/view/level/supportScript';
import { defineProps, ref ,defineEmits,defineExpose} from 'vue'

const isPopping = ref(false)
const isLoading = ref(false)
const emits = defineEmits(['userRankDailyCheckin'])
const props = defineProps<{
    dataSet: LevelViewData
}>()

const userRankDailyCheckin = () => {
    emits('userRankDailyCheckin')
}

const clickOnCard = () => {
    isPopping.value = true
    userRankDailyCheckin()
    setTimeout(() => {
        isPopping.value = false
    }, 300)
}

const isLoadingTrue = () =>{
    isLoading.value = true
}
const isLoadingFalse = () =>{
    isLoading.value = false
}

defineExpose({
    isLoadingTrue,
    isLoadingFalse
})

</script>
<style scoped>
.level_container {
    padding: 70px 0;
    --cell-min-width: 65px;

}

.top_card {
    margin: 0 20px;
    position: relative;
}

.top_card img {
    width: 100%;

}

.top_content img {
    width: 145px;
    position: absolute;
    top: 15px;
    right: 5px;
}

.text_1 {
    color: rgba(0, 0, 0, 0.65);
    font-size: 13px;
    opacity: 0.8;
}

.level_text {
    position: absolute;
    top: 15px;
    left: 20px;
}

.text_2 {
    color: #000000;
    font-size: 22px;
    font-weight: 700;
}

.level_name {
    position: absolute;
    top: 35px;
    left: 20px;
}

.value_text {
    position: absolute;
    width: 200px;
    top: 90px;
    left: 20px;
}

.value {
    position: absolute;
    top: 130px;
    left: 20px;
}

.level_scroll_wrapper {
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 0 5%;
    padding-bottom: 6px;
}

.level_scroll_wrapper::-webkit-scrollbar {
    display: none;
}


.level_list {
    display: flex;
    align-items: center;
    min-width: max-content;
    padding: 25px 0 8px;
    flex-direction: row;
    text-align: center;
    color: rgba(255, 255, 255, 0.45);
    overflow-x: auto;
    white-space: nowrap;
    gap: 8.5px;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.level_list::-webkit-scrollbar {
    display: none;
}

.level_cell {
    flex: 0 0 var(--level-cell-width);
    min-width: var(--cell-min-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.level_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 6px 6px;
    box-sizing: border-box;
}

.level_item img {
    width: 50px;
    height: auto;
    display: block;
}

.level_item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 6px 6px;
    box-sizing: border-box;
    flex-direction: row;
}

.level_item img {
    height: auto;
    display: block;
    width: 45px;
}

.level_label {
    margin-top: 6px;
    text-align: center;
    color: rgba(255, 255, 255, 0.45);
    font-size: 12px;
    width: 100%;
    word-break: break-word;
}

.manual_level_bar {
    display: flex;
    align-items: center;
    min-width: max-content;
    gap: 0;
    padding: 6px 0 0;
}

.manual_level_bar {
    display: flex;
    align-items: center;
    min-width: max-content;
    gap: 0;
    padding: 6px 0 0;
}

.step_line.left {
    width: calc(var(--level-cell-width) / 2);
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    margin-right: 4px;
}

.step_line.left.active {
    background-color: #F9C486;
}

.level_step {
    flex: 0 0 var(--level-cell-width);
    min-width: var(--cell-min-width);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
}

.connector {
    position: absolute;
    top: 6px;
    left: 50%;
    width: calc(var(--level-cell-width));
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 1;
}

.connector.active {
    background-color: #F9C486;
}

.step_dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 2;
}

.step_dot2 {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.15);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.level_step.active .step_dot {
    background-color: #F9C486;
}

.level_step.active .step_dot2 {
    /* background-color: transparent; */
}

.step_label {
    z-index: 3;
    text-align: center;
    font-size: 13.5px;
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.35);
}

.level_step.active .step_label {
    color: #F9C486;
}

.step_line {
    position: absolute;
    top: 6px;
    left: 50%;
    width: 100%;
    height: 0.5px;
    background-color: rgba(255, 255, 255, 0.15);
    ;
    z-index: 1;
}

.step_line.active {
    background-color: #F9C486;
}

.middle_container {
    padding: 15px 25px;
}

.middle_container img {
    width: 100%;
}

.label_container {
    padding: 0 25px;
}

.label_container img {
    width: 100%;
}

.label_text {
    margin: -75px 0 10px
}

.checkingDoneTick {
    display: flex;
    justify-content: right;
    align-items: center;
}

.checkingDoneTick img {
    width: 12px;
}

.day_text {
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.currency_text {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.currency_text span {
    color: #FFE400;
    font-size: 18px;
    padding-left: 5px;
}

.label_img {
    display: flex;
    justify-content: center;
}

.label_img img {
    width: 140px;
}

.activeText {
    /* padding: 20px 20px 20px 35px; */
    font-size: 14px;
    color: #00FFFF;
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.select_icon {
    display: flex;
    justify-content: center;
}

.select_icon img {
    width: 18px;
    padding: 20px;
}

.step_line.left {
    position: absolute;
    top: 6px;
    left: 15px;
    width: calc(50% / 6);
    height: 0.5px;
    background-color: #F9C486;
    z-index: 1;
}

.active_level {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
}

.bottom_text {
    padding: 25px;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

@media (min-width: 400px) {
    .level_item {
        /* image stays the same, cell width still controlled by var */
        width: 100%;
    }
}
</style>